<template>
  <div class="nwx-pagination">
    <div class="page-item prev-page"
         :tabindex="isFirstPage ? -1 : 0"
         :class="{'disabled': isFirstPage}"
         @click="prevPage()"
         @keyup.enter="prevPage()"
    >
    </div>
    <div class="page-item"
         :tabindex="paginator.enable ? 0 : -1"
         v-for="(paginator, index) in paginators"
         :key="index"
         :class="{ active: paginator.value === currentPage, skipper: !paginator.enable}"
         @click="paginator.enable ? setPage(paginator.value) : ''"
         @keyup.enter="paginator.enable ? setPage(paginator.value) : ''"
    >
      {{paginator.value}}
    </div>
    <div class="page-item next-page"
         :tabindex="isLastPage ? -1 : 0"
         :class="{'disabled': isLastPage}"
         @click="nextPage()"
         @keyup.enter="nextPage()"
    >
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NwxPagination',
    model: {
      prop: 'currentPage',
      event: 'pagination:update',
    },
    props: {
      currentPage: {
        type: Number,
        default: 1,
      },
      totalPages: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        eachSide: 1,
      };
    },
    computed: {
      isFirstPage() {
        return this.currentPage === 1;
      },
      isLastPage() {
        return this.currentPage === this.totalPages;
      },
      paginators() {
        const paginators = [];
        if (this.totalPages < this.eachSide * 2 + 4) {
          for (let i = 1; i < this.totalPages + 1; i += 1) {
            paginators.push({
              value: i,
              enable: true,
            });
          }
        } else {
          // eslint-disable-next-line
          if (this.currentPage < 3) { // first 3...3
            // eslint-disable-next-line
            for (let i = 1; i <= 3; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
            paginators.push({
              value: '...',
              enable: false,
            });
            for (let i = this.totalPages - 2; i <= this.totalPages; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
          } else if (this.currentPage > this.totalPages - 2) { // last 3...3
            // eslint-disable-next-line
            for (let i = 1; i <= 3; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
            paginators.push({
              value: '...',
              enable: false,
            });
            for (let i = this.totalPages - 2; i <= this.totalPages; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
          } else if (this.currentPage - 1 < 3) { // first 5...1
            // eslint-disable-next-line
            for (let i = 1; i <= 5; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
            paginators.push({
              value: '...',
              enable: false,
            });
            paginators.push({
              value: this.totalPages,
              enable: true,
            });
          } else if (this.currentPage > this.totalPages - 3) { // last 1...5
            paginators.push({
              value: 1,
              enable: true,
            });
            paginators.push({
              value: '...',
              enable: false,
            });
            // eslint-disable-next-line
            for (let i = this.totalPages - 4; i < this.totalPages + 1; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
          } else { // 1...3...1
            paginators.push({
              value: 1,
              enable: true,
            });
            paginators.push({
              value: '...',
              enable: false,
            });
            // eslint-disable-next-line
            for (let i = this.currentPage - this.eachSide; i < this.currentPage + this.eachSide + 1; i += 1) {
              paginators.push({
                value: i,
                enable: true,
              });
            }
            paginators.push({
              value: '...',
              enable: false,
            });
            paginators.push({
              value: this.totalPages,
              enable: true,
            });
          }
        }
        return paginators;
      },
    },
    watch: {
      currentPage(to) {
        if (to < 1 || to > this.totalPages) {
          this.$emit('pagination:update', 1);
        }
      },
      totalPages(to) {
        if (this.currentPage > to) {
          this.$emit('pagination:update', 1);
        }
      },
    },
    methods: {
      setPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.$emit('pagination:update', page);
        }
      },
      nextPage() {
        this.setPage(this.currentPage + 1);
      },
      prevPage() {
        this.setPage(this.currentPage - 1);
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../assets/variables';

  .nwx-pagination {
    display: inline-block;

    .page-item {
      display: inline-block;
      text-align: center;
      vertical-align: top;
      min-width: 30px;
      height: 30px;
      padding: 4px 6px;
      border-radius: 3px;
      font-size: 14px;
      color: @mainGray;
      background: #fff;
      border: 1px solid @inputGray;
      outline: 0;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: background 0.1s, border 0.1s;

      & + .page-item {
        margin-left: 10px;
      }

      &:not(.active):not(.skipper):not(.prev-page):not(.next-page):not(:focus):hover {
        border-color: @labelGray;
      }

      &:not(.active):not(.skipper):not(.disabled):focus {
        border-color: @mainBlue;
      }

      &.prev-page, &.next-page {
        @arrow: ~ '//img.netwrix.com/elements/partnerPortal/pipeline/pagination-arrow.svg';
        background-image: url(@arrow);
        background-position: center;
        background-repeat: no-repeat;
        border-color: #fff;

        &.disabled {
          opacity: 0.7;
          cursor: default;
        }
      }

      &.prev-page {
        transform: rotate(180deg);
      }

      &.active {
        background: @mainBlue;
        border-color: @mainBlue;
        color: #fff;
      }

      &.skipper {
        background: transparent;
        border-color: transparent;
      }
    }
  }
</style>
